import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ActionsBottomSheetCtrl implements IController {
  actions: any;
  ids: any;
  selectedServices: any;

  private extraActionNames: any;
  private servicesCount: any;
  private enabledActions: any;
  private extraActions: any;
  public isMobile: boolean;

  /* @ngInject */
  constructor(private $mdBottomSheet, private deliveriesConstants, private $mdMedia) {
  }

  $onInit() {
    this.extraActionNames = this.deliveriesConstants.extraActions;
    this._initActions();
  }

  $onChanges(changes) {
    if (changes.actions && !changes.actions.isFirstChange()) {
      this._initActions();
    }
    if (changes.ids && !changes.ids.isFirstChange()) {
      this._initActions();
    }
  }

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
  };

  onClose() {
    this.$mdBottomSheet.hide();
  }

  onActionSelect(action) {
    this.$mdBottomSheet.hide(action);
  }

  private _initActions() {
    this.servicesCount = _.get(this.ids, 'length', '');
    this.enabledActions = _.filter(this.actions, (a) => {
      return !this._isExtraAction(a);
    })
    this.extraActions = _.filter(this.actions, (a) => {
      return this._isExtraAction(a);
    })
  }

  private _isExtraAction(action) {
    return _.includes(this.extraActionNames, action.title);
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('actionsBottomSheet', {
    bindings: {
      actions: '<',
      selectedServices: '<?',
      ids: '<'
    },
    template: require('./actions-bottom-sheet.html').default,
    controller: ActionsBottomSheetCtrl
  });
